import React from "react";
import MainSettings from "../Components/Settings";

const Settings = () => {
	return <MainSettings />;
};

export default Settings;
